// Environment configuration for Resume Tailor App (GCP)
// Supports development (local) and production (GCP Cloud Run) environments

const config = {
  development: {
    API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    ENVIRONMENT: 'development',
    DEBUG_MODE: true,
    ENABLE_ANALYTICS: false
  },
  production: {
    // Runtime config (set by config.js in public/) takes priority over build-time env vars
    // This ensures GCS-hosted builds always use the correct Cloud Run URL
    // Use ?? (nullish coalescing) so that "" (empty string for Firebase Hosting) is preserved
    // The || operator would treat "" as falsy and fall back to the hardcoded URL
    API_BASE_URL: window.__RUNTIME_CONFIG__?.API_BASE_URL ?? 'https://rankify-api.aramailabs.com',
    ENVIRONMENT: 'production',
    DEBUG_MODE: false,
    ENABLE_ANALYTICS: true
  }
};

// Determine environment based on hostname or env var
const getEnvironment = () => {
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }

  // Only treat localhost as development
  if (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1') {
    return 'development';
  }

  // Everything else is production (GCS, Cloud Run, API Gateway, custom domain)
  return 'production';
};

const currentConfig = config[getEnvironment()] || config.development;

export default currentConfig;